import Translated from "./../Translated";

const ShopPaymentTermsNote = (props) => {
  return (
    <div className={props.className}>
      <a
        href="https://www.svea.com/fi-fi/tietoa-meista/sopimusehdot/115/svea-payments-yleiset-kayttoehdot"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Translated translationKey="payment_terms_label" />
      </a>
    </div>
  );
};

export default ShopPaymentTermsNote;
